import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';
import { span } from 'utils/stringUtils';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: grid;
  margin-top: 40px;
  gap: var(--Section-Margin) var(--Grid-Gap);
  
  grid-template-areas:
    "banner"
    "pageContent"
    "rightRail";

  @media (${breakpoint.lgMin}) {
    grid-template-columns: repeat(12, 1fr);
    grid-template-areas: 
      "${span('banner', 12)}"
      "${span('pageContent', 8)} ${span('rightRail', 4)}";
  }

`;

export const Banner = styled.div<{ theme: Theme }>`
  grid-area: banner;
  display: flex;
  flex-direction: column;
  gap: 24px;

  address {
    ${getBodyStyle('graphikCond', { default: 'large' }, 'regular')};
    color: ${getColor('textSecondary')};
    font-style: normal;
  }

  a {
    width: max-content;
  }
`;

export const PageContent = styled.div<{ theme: Theme }>`
  grid-area: pageContent;
  display: flex;
  flex-direction: column;
  gap: var(--Grid-Gap);
`;

export const RightRail = styled.div<{ theme: Theme }>`
  grid-area: rightRail;
  display: flex;
  flex-direction: column;
  gap: var(--Grid-Gap);
`;
